import React, { useRef } from 'react';

import 'slick-carousel/slick/slick.css';

const VideoSlider = () => {
  let toogleRef = useRef([]);

  return (
    <div className="flex flex-col">
      <h2 className="flex justify-start md:justify-center items-center font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black mb-[48px]">
        Video Testimonials
      </h2>
      <div className={`max-w-[600px] pr-0 `}>
        <div className="relative max-w-[443px] rounded-[10px] overflow-hidden mb-[25px]">
          <video
            controls={true}
            onChange={() => tooglePlayPause(1, toogleRef.current[1].paused)}
            webkitplaysinline={'true'}
            playsInline
            width={'100%'}
            ref={element => toogleRef.current.push(element)}
          >
            <source src="https://weprodigi.com/uploads/images/seo/Arara_Video.mp4#t=0.1" type="video/mp4" />
          </video>
        </div>
      </div>
      <a href="https://weprodigi.com/testimonals" className="flex justify-end w-full   text-[#09AF77] hover:text-black">
        <p className="text-[16px] font-[500] leading-[20px]">{'See our testimonials >'}</p>
      </a>
    </div>
  );
};

export default VideoSlider;
